import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Switch,
} from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import DownloadFilteredButton from './DownloadFilteredButton.jsx';
import { ClearOutlined } from '@ant-design/icons';

function filterOption(input, option) {
  return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
}

const getInput = (i) => {
  if (i.type === 'input') {
    return (
      <Form.Item
        name={i.name}
        label={i.label}
        style={{ width: '20%', marginBottom: 0 }}
      >
        <Input />
      </Form.Item>
    );
  }
  if (i.type === 'switch') {
    return (
      <Form.Item
        name={i.name}
        label={i.label}
        style={{ width: '20%', marginBottom: 0 }}
        valuePropName="checked"
      >
        <Switch defaultChecked={false} className="form-checker" />
      </Form.Item>
    );
  }
  if (i.type === 'date') {
    return (
      <Form.Item
        name={i.name}
        label={i.label}
        style={{ width: '20%', marginBottom: 0 }}
      >
        <DatePicker.YearPicker placeholder="Укажите год" />
      </Form.Item>
    );
  }
  if (i.type === 'select') {
    return (
      <Form.Item
        name={i.name}
        label={i.label}
        style={{ width: '20%', marginBottom: 0 }}
      >
        <Select
          options={i?.selectOptions ?? []}
          style={{ width: '100%' }}
          mode={i?.mode || null}
          filterOption={filterOption}
          allowClear
        />
      </Form.Item>
    );
  }
};

const prepareValues = (values) => {
  for (const [key, value] of Object.entries(values)) {
    if (key.includes('year_of_purchase')) {
      values[key] = parseInt(dayjs(value).format('YYYY'));
    }
    if (!value && value !== false) {
      delete values[key];
    }
  }
  return values;
};

function FilterBlock({ items, download }) {
  const [form] = Form.useForm();
  const [search, setSearch] = useSearchParams();

  useEffect(() => {
    if (search?.size > 0) {
      search.forEach((value, name) => {
        if (value === 'false') {
          form.setFieldValue(name, false);
        } else if (value === 'true') {
          form.setFieldValue(name, true);
        } else if (name.includes('year_of_purchase')) {
          form.setFieldValue(name, dayjs(value));
        } else form.setFieldValue(name, value);
      });
    }
  });

  const onReset = () => {
    form.resetFields();
    setSearch();
  };

  const prepareDownload = () => {
    const payload = prepareValues(form.getFieldsValue());

    // if (Object.keys(payload).length === 0) {
    //     message.error('Ни один фильтр не заполнен', 2).then(() => true)
    // } else {
    download(payload);
    // initDownload(payload)
    // }
  };

  return (
    <Card style={{ width: '100%' }} size={'small'} id="filter-block">
      <Row
        justify={'start'}
        align={'middle'}
        style={{ gap: 24, width: '100%', flexWrap: 'nowrap' }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={(v) => setSearch(prepareValues(v))}
          style={{ flex: 1 }}
          onKeyDown={(e) => e.key === 'Enter' && form.submit()}
        >
          {/*flexWrap: 'nowrap' if asked to return to design*/}
          <Row style={{ gap: 16, marginBottom: 24 }}>
            {items?.map((i) => getInput(i))}
          </Row>
        </Form>
        <Row style={{ gap: 16, marginTop: 4, flexShrink: 0 }}>
          <Button
            type="primary"
            className="btn-primary"
            onClick={() => form.submit()}
          >
            Применить фильтр
          </Button>
          <Button
            onClick={onReset}
            type={'primary'}
            ghost
            icon={<ClearOutlined />}
          />
        </Row>
        {download ? (
          <DownloadFilteredButton onDownload={prepareDownload} />
        ) : null}
      </Row>
    </Card>
  );
}

export default FilterBlock;
